import {
  Grid,
  Paper,
  Button,
  TextField,
  Typography,
  FormControl,
  MenuItem,
  Select,
  InputLabel
} from "@material-ui/core";

import { useState, useEffect } from "react";
import { createMarkup } from "../helpers";
import TotalResults from "./TotalResults";
import uploadFileToBlob, { getBlobFile } from '../common/AzureBlob';



const QuizAnswers = ({
  classes,
  quizData,
  email,
  quizResults,
  translationString
}) => {
  const [processedAnswers, setProcessedAnswers] = useState([]);
  const [responseList, setResponseList] = useState([]);
  const [finalScore, setFinalScore] = useState();

  useEffect(() => loadJSON());

  const handleClickSubmit = (e) => {
    e.preventDefault();
    getResult("");
  };

  const convertToCsv = (list) => {
    const parsedJson = list;
    if (
      !Array.isArray(parsedJson) ||
      !parsedJson.every((p) => typeof p === "object" && p !== null)
    ) {
      return;
    }
    const heading = Object.keys(parsedJson[0]).join(";");
    const body = parsedJson.map((j) => Object.values(j).join(";")).join("\n");

    const data = new Blob([`${heading}\n${body}`], {type: 'text/csv', });
    const filename = email.replace('@','__');
    uploadFileToBlob(data, filename + '.csv');
  };

  const loadJSON = async () => {
    // const value = "elgrandml__hotmail.com.json";
    const queryParams = new URLSearchParams(window.location.search);
    let email = queryParams.get("email");

    if(email){
      email = email.replace('@','__') + '.json';
      await getBlobFile(email)
        .then((parsedJSON) => {
          getProcessedResult(parsedJSON);
        });
    }
  }

  const saveJSON = (list) => {
    const parsedJson = list;
    if (
      !Array.isArray(parsedJson) ||
      !parsedJson.every((p) => typeof p === "object" && p !== null)
    ) {
      return;
    }
    const json = JSON.stringify(parsedJson, null, 2);

    const data = new Blob([`${json}`], { type: "application/json" });
    const filename = email.replace('@','__');
    uploadFileToBlob(data, filename + '.json');
  };

  const getProcessedResult = (parsedJSON) => {
    // e.preventDefault();
    let totalRates = [];
    let totalScore = 0;
    const topicLength = quizData.results.length;
    for(var i=1;i<=topicLength;i++){
      // eslint-disable-next-line no-loop-func
      const topicAnswers = parsedJSON.filter((topic) => topic.topic_id === i);
      // eslint-disable-next-line no-loop-func
      const perc = quizData.results.find((t)=> t.topic_id === i).topic_rate;

      const topicAnswersTotal = topicAnswers.reduce((total, currentValue) => total = total + parseInt(currentValue.score),0);

      let rate_prom = topicAnswersTotal/topicAnswers.length;
      totalScore = totalScore + ((perc * rate_prom) / 100);
      totalRates.push(
        { topic_id: i, topic_score: topicAnswersTotal, topic_rate: rate_prom}
      );
    }

    // sendEmail();
    totalScore = (totalScore * 100) / 6;
    
    totalScore = Math.round(totalScore * 100) / 100;
    
    setFinalScore(totalScore);
    setProcessedAnswers(totalRates);
  };

  const getResult = () => {
    // e.preventDefault();
    let totalRates = [];
    let totalScore = 0;
    const topicLength = quizData.results.length;
    for(var i=1;i<=topicLength;i++){
      // eslint-disable-next-line no-loop-func
      const topicAnswers = responseList.filter((topic) => topic.topic_id === i);
      // eslint-disable-next-line no-loop-func
      const perc = quizData.results.find((t)=> t.topic_id === i).topic_rate;

      const topicAnswersTotal = topicAnswers.reduce((total, currentValue) => total = total + parseInt(currentValue.score),0);

      let rate_prom = topicAnswersTotal/topicAnswers.length;
      totalScore = totalScore + ((perc * rate_prom) / 100);
      totalRates.push(
        { topic_id: i, topic_score: topicAnswersTotal, topic_rate: rate_prom}
      );
    }
    const finalResponseList = responseList.map(resp => {
        return {
          email: email,
          ...resp
        };
    });

    setResponseList(finalResponseList);
    convertToCsv(finalResponseList);
    // sendEmail();
    totalScore = (totalScore * 100) / 6;
    
    totalScore = Math.round(totalScore * 100) / 100;
    
    saveJSON(finalResponseList);
    setFinalScore(totalScore);
    setProcessedAnswers(totalRates);
  };

  const handleAnswerChange = (e, selectedQuestion, topicId, topicTitle, question) => {
    e.preventDefault();
    const { value } = e.target;

    const existResponse = responseList.some((q) => q.quiz === selectedQuestion);
    if(!existResponse){
      setResponseList([
        ...responseList,
        { topic_id: topicId, topic_title: topicTitle, quiz: question,score: parseInt(value), id_quiz: selectedQuestion }
      ]);
    }
    else{
      const newResponseList = responseList.map(resp => {
        if (resp.quiz === selectedQuestion) {
          return {
            ...resp,
            score: value
          };
        }
      });
      setResponseList(newResponseList);
    }
  };

  useEffect(() => {
    window.scrollTo(0, "20px");
  }, []);

  return !processedAnswers || !processedAnswers.length ? (
    <>
      <Typography variant="h1" className={classes.mainTitle}>
        {translationString.title}<span>&reg;</span>
      </Typography>
      <form onSubmit={handleClickSubmit}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            {quizData.results.map((topic)=>{
              return(
                <Paper key={topic.id} className={classes.paper}>               
                  <div className={classes.topic_wrapper}>
                    <Typography variant="h2" className={classes.subTitle}>
                      <span dangerouslySetInnerHTML={createMarkup(topic.title)} />
                    </Typography>

                    <p dangerouslySetInnerHTML={createMarkup(topic.topic_description)}/>
                    {topic.categories.map((category)=>{
                      return(
                        <p dangerouslySetInnerHTML={createMarkup(category.category_description)}></p>
                      )
                    })}
                    
                    {topic.categories.map((category)=>{
                      return(
                        <div className={classes.category_wrapper}>
                          {/* <Typography variant="h3" className={classes.category}>
                            <span dangerouslySetInnerHTML={createMarkup(category.category)} />
                          </Typography> */}
                          {/* <p dangerouslySetInnerHTML={createMarkup(category.category_description)}></p> */}
                          {category.question_list.map((quiz) => (
                            <Paper key={quiz.question} className={classes.paperCategory}>
                                <p className={classes.question} dangerouslySetInnerHTML={createMarkup(quiz.question)} />
                              <FormControl fullWidth variant="outlined">
                                <InputLabel id="answer-select-label">
                                  {translationString.answer_label}
                                </InputLabel>
                                <Select
                                  required
                                  className={classes.selectItem}
                                  name={`answer${quiz.id}`}
                                  id={`answer-select${quiz.id}`}
                                  key={quiz.id}
                                  label="Elija una respuesta"
                                  labelid={`answer-select-label${quiz.id}`}
                                  onChange={(e) => handleAnswerChange(e, quiz.id, topic.topic_id, topic.title, quiz.question)}
                                >
                                  
                                    <MenuItem key={1} value={0}>
                                      <span>{translationString.responses.never}</span>
                                    </MenuItem>
                                    <MenuItem key={2} value={1}>
                                      <span>{translationString.responses.rarely}</span>
                                    </MenuItem>
                                    <MenuItem key={3} value={2}>
                                      <span>{translationString.responses.ocasionally}</span>
                                    </MenuItem>
                                    <MenuItem key={4} value={3}>
                                      <span>{translationString.responses.sometimes}</span>
                                    </MenuItem>
                                    <MenuItem key={5} value={4}>
                                      <span>{translationString.responses.almost_always}</span>
                                    </MenuItem>                                                                                                                                                
                                    <MenuItem key={6} value={5}>
                                      <span>{translationString.responses.always}</span>
                                    </MenuItem>                                    
                                </Select>
                              </FormControl>                              
                            </Paper>
                          ))}
                        </div>
                      )})}
                  </div>
                </Paper>                 
            )})
            }
            <div className={classes.buttonContainer}>
              <Button
                className={classes.submitButton}
                variant="contained"
                color="primary"
                type="submit"
              >
                {translationString.send_button_text}
              </Button>       
            </div>
          </Grid>
        </Grid>
      </form>
    </>
  ) : (
    <TotalResults
      classes={classes}
      processedAnswers={processedAnswers}
      finalScore={finalScore}
      quizResults={quizResults}
      translationString={translationString}
    />
  );
};

export default QuizAnswers;
